import { useMemo } from "react"
import { appConstants } from "../../appConstants"
import { BSMorphology } from "../../dto/beem-shot/BSMorphology/BSMorphology"
import { BSMorphologyCreationDto } from "../../dto/beem-shot/BSMorphology/BSMorphologyCreationDto"
import { BSMorphologyUpdateDto } from "../../dto/beem-shot/BSMorphology/BSMorphologyUpdateDto"
import { useHttp } from "../use-http"

type BSMorphologyHook = {
  createBSMorphology(bsMorphologyCreationDto: BSMorphologyCreationDto): Promise<BSMorphology>
  putBSMorphology(bsMorphologyUpdateDto: BSMorphologyUpdateDto): Promise<BSMorphology>
  getBSMorphology(bsBuildingId: string): Promise<BSMorphology>
  createBSItemsForMorphology(bsBuildingId: string): Promise<Response>
}

export function useBSMorphology(): BSMorphologyHook {
  const { post, put, get } = useHttp()

  return useMemo(
    () => ({
      createBSMorphology(bsMorphologyCreationDto: BSMorphologyCreationDto): Promise<BSMorphology> {
        return post(appConstants.apiEndpoints.BEEM_SHOT_BUILDING_MORPHOLOGY, bsMorphologyCreationDto).then((response) =>
          response.json()
        )
      },
      putBSMorphology(bsMorphologyUpdateDto: BSMorphologyUpdateDto): Promise<BSMorphology> {
        return put(appConstants.apiEndpoints.BEEM_SHOT_BUILDING_MORPHOLOGY, bsMorphologyUpdateDto).then((response) =>
          response.json()
        )
      },
      getBSMorphology(bsBuildingId: string): Promise<BSMorphology> {
        return get(appConstants.apiEndpoints.BEEM_SHOT_BUILDING_MORPHOLOGY, [
          {
            key: "bsBuildingId",
            value: bsBuildingId,
          },
        ]).then((response) => {
          if (response.status === 404) {
            return Promise.resolve(undefined)
          } else {
            return response.json()
          }
        })
      },
      createBSItemsForMorphology(bsBuildingId: string): Promise<Response> {
        return post(appConstants.apiEndpoints.BEEM_SHOT_BUILDING_CREATE_BS_ITEMS, {}, [
          {
            key: "bsBuildingId",
            value: bsBuildingId,
          },
        ])
      },
    }),
    [post, put, get]
  )
}
